import styled, { createGlobalStyle } from "styled-components";

import { Modal } from "antd";

export const FloatingWrapper = styled.div<{ isFullscreen?: boolean }>`
  ${(props) =>
    props.isFullscreen &&
    `
    bottom: 0;
    right: 0;
    top: 48px;
    left: 308px;
    width: calc(100vw - 308px);
    height: calc(100vh - 48px);
  `}

  @media (max-width: 640px) {
    ${(props) =>
      props.isFullscreen &&
      `
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
    `}
  }
`;

export const GlobalModalStyles = createGlobalStyle`
  .modal-bottom-right-wrap {
    display: flex !important;
    align-items: flex-end !important;
    justify-content: flex-end !important;
    padding: 0 40px 40px 0 !important;
    // overflow-y: auto !important;
    pointer-events: none !important;
    position: fixed;
    inset: 0;

    z-index: 1000 !important;
 
    &.modal-index-1:not(.modal-fullscreen) {
      z-index: 1005 !important;
    }

    .ant-modal {
      pointer-events: auto !important;
      margin: 0 !important;
      top: auto !important;
      width: fit-content !important;
      max-height: calc(100vh - 80px) !important;
      display: flex !important;
      flex-direction: column !important;
    }

    &.modal-fullscreen {
      padding: 0 !important;
      z-index: 1010 !important;
      top: 48px !important;
      left: 308px !important;
      right: 0 !important;
      bottom: 0 !important;
      width: calc(100vw - 308px) !important;
      height: calc(100vh - 48px) !important;
      overflow: hidden !important;

      &.modal-fullscreen-index-0 {
        z-index: 1010 !important;
      }
      &.modal-fullscreen-index-1 {
        z-index: 1015 !important;
      }

      .ant-modal {
        width: 100% !important;
        max-width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        margin: 0 !important;
      }

      .ant-modal-content {
        width: 100% !important;
        height: 100% !important;
        border-radius: 0 !important;
      }
    }

    &.modal-index-1:not(.modal-fullscreen):not(.has-fullscreen) {
      padding-right: 500px !important;
    }

    &.modal-index-1.modal-fullscreen {
      padding-right: 0 !important;
    }

    @media (max-width: 640px) {
      padding: 0 12px 12px !important;

      .ant-modal {
        width: calc(100vw - 24px) !important;
        max-width: calc(100vw - 24px) !important;
      }

      .ant-modal-content {
        width: 100% !important;
        max-width: 100% !important;
      }

      &.modal-index-1:not(.modal-fullscreen):not(.has-fullscreen) {
        padding-right: 12px !important;
      }

      &.modal-fullscreen {
        padding: 0 !important;
        top: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        width: 100vw !important;
        height: 100vh !important;

        .ant-modal {
          width: 100% !important;
          max-width: 100% !important;
          height: 100% !important;
          max-height: 100% !important;
        }

        .ant-modal-content {
          width: 100% !important;
          max-width: 100% !important;
          height: 100% !important;
        }
      }
    }
  }

  /* Highest priority for confirm modal */
  .modal-confirm-highest {
    z-index: 1050 !important;
  }

  /* Ensure clicks pass through the modal container if not on the modal itself */
  .ant-modal-root {
    pointer-events: none !important;
  }
  .ant-modal-wrap, .ant-modal-mask {
    pointer-events: auto !important;
  }
  .modal-bottom-right-wrap {
    pointer-events: none !important;
  }
  .modal-bottom-right-wrap .ant-modal {
    pointer-events: auto !important;
  }
`;

export const StylesModalContainer = styled(Modal)<{
  isFullscreen?: boolean;
}>`
  ${(props) =>
    props.isFullscreen &&
    `
    top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
  `}

  ${(props) =>
    props.isFullscreen ? `transform: scale(1);` : `transform: scale(0.98);`}

  .ant-modal-content {
    width: 440px;
    border-radius: 16px;
    transition: opacity 0.2s ease, transform 0.3s ease;
    transform-origin: bottom right;
    will-change: transform;
    ${(props) =>
      props.isFullscreen &&
      `
      width: 100% !important;
      height: 100% !important;
      border-radius: 0 !important;
    `}
    .ant-modal-close {
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 54px;
      height: 64px;
    }
    .ant-modal-header {
      border-top-right-radius: 16px;
      border-top-left-radius: 16px;
      background: #1a2a5a;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 24px;
      padding-right: 32px;
      gap: 8px;
      ${(props) =>
        props.isFullscreen &&
        `
        border-top-right-radius: 0 !important;
        border-top-left-radius: 0 !important;
      `}

      .ant-modal-title {
        color: #fff;
        flex: 1;
      }
    }
    .ant-modal-body {
      min-height: 500px;
      ${(props) =>
        props.isFullscreen &&
        `
        height: calc(100vh - 48px - 64px) !important;
        min-height: auto;
        border-bottom-left-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      `}
    }
  }

  &.ant-modal-zoom-enter,
  &.ant-modal-zoom-appear {
    animation-duration: 0.2s;
    animation-timing-function: cubic-bezier(0.08, 0.82, 0.17, 1);
  }

  &.ant-modal-zoom-leave {
    animation-duration: 0.15s;
    animation-timing-function: cubic-bezier(0.78, 0.14, 0.15, 0.86);
  }

  .modal-header-with-btn {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .modal-header-with-btn span {
    flex: 1;
  }

  .modal-fullscreen-btn,
  .modal-copy-btn {
    background: none;
    border: none;
    color: #ffffff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 32px;
    height: 32px;
    transition: all 0.3s ease;
    flex-shrink: 0;
    margin-right: 12px;

    &:hover {
      opacity: 0.8;
    }

    &:focus {
      outline: none;
    }
  }

  .modal-header-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  }

  .chat-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 557.5px;
    overflow: hidden;
    ${(props) =>
      props.isFullscreen &&
      `
      height: 100% !important;
    `}

    &__actions {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      .ant-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: #1e3666;
        border-color: #1e3666;
        border-radius: 8px;
        width: 100%;

        &:hover,
        &:focus {
          background: #1e3666;
          opacity: 0.9;
        }
      }
    }

    &__search {
      height: 32px;

      .ant-input-affix-wrapper,
      .ant-input-affix-wrapper-focused {
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        padding: 0 12px;
        height: 32px;
      }

      .ant-input {
        padding: 0;
      }

      .ant-input-prefix {
        color: #00000040;
      }
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 8px;
      flex: 1;
      min-height: 360px;
      max-height: ${(props) => (props.isFullscreen ? "none" : "530px")};
      overflow-y: auto;
      overflow-x: hidden;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      scrollbar-gutter: stable;

      backface-visibility: hidden;
      transform: translateZ(0);
    }

    &__item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
      padding: 8px 16px;
      background: #fafafa;
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      text-align: left;
      cursor: pointer;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      animation: slideIn 0.3s ease-out;
      will-change: transform, opacity;
      backface-visibility: hidden;

      &:hover {
        border-color: #d9d9d9;
        background-color: #f5f5f5;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      &--updated {
        animation: highlightUpdate 2s ease-out;
        border-color: #1890ff;
        background: linear-gradient(
          to right,
          rgba(24, 144, 255, 0.05) 0%,
          #fafafa 100%
        );
      }

      &--unread {
        background-color: #f0f7ff !important;
        border-color: #bae7ff !important;
      }
    }

    @keyframes slideIn {
      from {
        opacity: 0;
        transform: translateY(-8px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes highlightUpdate {
      0% {
        background: linear-gradient(
          to right,
          rgba(24, 144, 255, 0.15) 0%,
          rgba(24, 144, 255, 0.05) 50%,
          #fafafa 100%
        );
        border-color: #1890ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
      }
      50% {
        background: linear-gradient(
          to right,
          rgba(24, 144, 255, 0.1) 0%,
          rgba(24, 144, 255, 0.03) 50%,
          #fafafa 100%
        );
        border-color: #40a9ff;
        box-shadow: 0 0 0 1px rgba(24, 144, 255, 0.1);
      }
      100% {
        box-shadow: none;
      }
    }

    &__item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 6px;
    }

    &__item-id-title {
      font-size: 15px;
      font-weight: 500;
      margin: 0;
      color: #1a1a1a;
      line-height: 1.6;
      display: flex;
      gap: 4px;
      width: 100%;
      overflow: hidden;

      span:first-child {
        flex-shrink: 0;
      }
    }

    &__item-title-wrapper {
      flex: 1;
      min-width: 0;
      display: flex;
    }

    &__item-title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      min-width: 0;
      display: block;
    }

    &__item-meta {
      width: 100%;
      font-size: 12px;
      color: #989ca6;
    }

    &__item-user-info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      flex-wrap: wrap;
      width: 100%;
    }

    &__item-user-wrapper {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }

    &__item-company {
      color: #a0a9b8;
      word-break: break-word;
    }

    &__item-requester {
      color: #000000d9;
      font-weight: 500;
      word-break: break-word;
    }

    &__item-icon {
      color: #989ca6;
      font-size: 16px;
      flex-shrink: 0;
    }

    &__item-time {
      margin: 0;
      flex-shrink: 0;
      flex: 0 0 auto;
      margin-left: 0;
      word-break: break-word;
    }

    &__item-status {
      border-radius: 2px !important;
      padding: 1px 8px !important;
      font-size: 12px !important;
    }

    &__item-status--new {
      color: #f5222d !important;
      border-color: #ffa39e !important;
      background: #fff1f0 !important;
    }

    &__item-status--in-progress {
      color: #faad14 !important;
      border-color: #ffd591 !important;
      background: #fff7e6 !important;
    }

    &__item-status--done {
      color: #52c41a !important;
      border-color: #b7eb8f !important;
      background: #f6ffed !important;
    }

    &__empty {
      text-align: center;
      padding: 24px 0;
      color: #6b7280;
      font-size: 14px;
    }

    &__item-skeleton {
      padding: 8px 16px;
      background: #fafafa;
      border: 1px solid #f0f0f0;
      border-radius: 8px;

      .ant-skeleton-content {
        .ant-skeleton-title {
          margin-bottom: 12px;
        }
        .ant-skeleton-paragraph {
          margin-bottom: 0;
        }
      }
    }

    &__loading-more {
      padding: 8px 16px;
      background: #fafafa;
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      margin-top: 8px;

      .ant-skeleton-content {
        .ant-skeleton-title {
          margin-bottom: 12px;
        }
        .ant-skeleton-paragraph {
          margin-bottom: 0;
        }
      }
    }
  }

  .create-chat {
    display: flex;
    flex-direction: column;
    min-height: 500px;
    ${(props) =>
      props.isFullscreen &&
      `
      height: calc(100vh - 48px - 64px) !important;
      min-height: auto;
    `}

    &__header {
      margin: -24px -24px 0 -24px;
      box-shadow: 0 2px 8px 0 #00000017;
      padding: 12px 16px 20px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      &__back {
        display: inline-flex;
        align-items: center;
        column-gap: 6px;
        color: #1e3666;
        background: transparent;
        border: none;
        padding: 0;
        cursor: pointer;

        &:hover {
          color: #15264d;
        }

        .icon-back {
          font-size: 16px;
        }

        &-label {
          font-size: 13px;
        }
      }

      &__title {
        font-size: 14px;
        font-weight: 500;
        margin: 0;
      }
    }

    &__content {
      padding-top: 12px;
      flex: 1;
      display: flex;
      flex-direction: column;

      .ant-form {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .btn-upload {
        display: inline-flex;
        align-items: center;
        gap: 6px;

        .attach-icon {
          font-size: 16px;
          color: #00000040;
          transform: rotate(45deg);
        }
      }

      .btn-upload-rcm {
        color: #00000073;
        margin-top: 4px;
      }

      .create-chat__form-items {
        ${(props) =>
          props.isFullscreen &&
          `
          flex: 1;
          overflow-y: auto;
          padding-bottom: 24px;
        `}
      }

      .footer-chat {
        box-shadow: 0 -2px 8px 0 #00000014;
        padding: 8px 16px ${(props) => (props.isFullscreen ? "60px" : "20px")};
        margin: 0 -24px -24px;
        // margin-top: auto;

        .btn-submit {
          background: #1e3666;
          width: 100%;
          height: 40px;
          border-radius: 6px;

          &[disabled],
          &.ant-btn-disabled {
            background: #e7e7e7 !important;
            border-color: #e7e7e7 !important;
            color: #fff !important;
            cursor: not-allowed !important;
          }
        }
      }
    }
  }

  .chat-realtime {
    ${(props) =>
      props.isFullscreen &&
      `
      height: calc(100vh - 48px - 64px) !important;
      display: flex;
      flex-direction: column;
    `}
    &__header {
      margin: -24px -24px 12px;
      padding: 12px 16px 16px;
      box-shadow: 0 2px 8px #00000017;
      display: flex;
      align-items: center;
      gap: 12px;

      &__back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        color: #1e3666;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0;

        &:hover {
          color: #15264d;
        }

        .icon-back {
          font-size: 16px;
        }

        &-label {
          font-size: 13px;
        }
      }

      &__id {
        font-size: 12px;
        color: #6b7280;
      }

      &__title {
        font-size: 14px;
        font-weight: 500;
        color: #1f2937;
      }

      &__status {
        border-radius: 12px !important;
        padding: 2px 8px !important;
        font-size: 12px !important;
      }

      &__status--new {
        color: #f5222d !important;
        border-color: #ffa39e !important;
        background: #fff1f0 !important;
      }

      &__status--in-progress {
        color: #faad14 !important;
        border-color: #ffd591 !important;
        background: #fff7e6 !important;
      }

      &__status--done {
        color: #52c41a !important;
        border-color: #b7eb8f !important;
        background: #f6ffed !important;
      }
    }

    &__header__info {
      display: flex;
      flex-direction: column;
      gap: 2px;
      flex: 1;
    }
  }
`;
export const ModalSizeWrapper = styled.div<{ isFullscreen?: boolean }>`
  width: ${({ isFullscreen }) => (isFullscreen ? "100%" : "440px")};
  height: ${({ isFullscreen }) => (isFullscreen ? "100%" : "auto")};
  max-width: 100%;

  @media (max-width: 640px) {
    width: ${({ isFullscreen }) =>
      isFullscreen ? "100%" : "calc(100vw - 24px)"};
  }
  /* overflow: hidden; */
`;
